import { render, staticRenderFns } from "./modal-dashboard.vue?vue&type=template&id=76e46590"
import script from "./modal-dashboard.vue?vue&type=script&lang=js"
export * from "./modal-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports